import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'

const CategoryBanner = ({ title = '', content = '', button = null, backgroundImage = null }) => {

  return (
    <section className={`category-banner`}>
      {backgroundImage?.localFile &&
        <div className='category-banner__bg'>
          <GatsbyImage image={getImage(backgroundImage?.localFile)} alt={title} />
        </div>
      }
      <Fade bottom distance={'40px'}>
        <div className='category-banner__inner'>
          <h1 className='category-banner__title' dangerouslySetInnerHTML={{ __html: title }} />
          <div className='category-banner__content'>
            <div className='category-banner__text' dangerouslySetInnerHTML={{ __html: content }} />
            {button?.url &&
              <Link to={button.url} className='category-banner__button btn btn--arrow'>
                <span>{button.title}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="13.675" height="10.262" viewBox="0 0 13.675 10.262">
                  <path d="M16.555,22.112l-.917-.9,3.584-3.584H8v-1.28H19.222l-3.605-3.605.917-.9,5.142,5.142Z" transform="translate(-8 -11.85)" fill="#FFFFFF" />
                </svg>
              </Link>
            }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default CategoryBanner